'use client';

import clsx from 'clsx';
import Icon from '@/components/icon/Icon';
import { useKeyboardActivation } from '../hooks/useKeyboardActivation';

type NavSectionButtonProps = {
  title: string;
  isOpen: boolean;
  controlsId: string;
  onToggle: () => void;
  className: string;
};

/**
 * Left-column section of a mega-menu panel that reveals a sub-panel.
 * Enter and Space are handled explicitly, like the top-level trigger.
 */
export const NavSectionButton = ({
  title,
  isOpen,
  controlsId,
  onToggle,
  className,
}: NavSectionButtonProps) => {
  const activation = useKeyboardActivation(onToggle);

  return (
    <button
      type="button"
      aria-expanded={isOpen}
      aria-controls={controlsId}
      onClick={activation.onClick}
      onKeyDown={activation.onKeyDown}
      className={clsx(
        'group/sublinks',
        className,
        isOpen && '!bg-brand-100 !text-brand-700',
      )}
    >
      {title}
      <Icon
        name="arrow-right"
        size={18}
        className={clsx(
          'text-brand-700 opacity-0 group-hover/sublinks:opacity-100',
          isOpen && 'opacity-100',
        )}
      />
    </button>
  );
};

export default NavSectionButton;
